import React from 'react';

import _ from 'lodash';
import { firebaseRoot } from './../utils/firebase-utils';
import ReactFireMixin from 'reactfire';
import { Router, Route, Link } from 'react-router';

import MobileHeader from '../components/MobileHeader/MobileHeader';
import TouchLink from '../components/TouchLink';

import ChapterItem from '../components/ChapterItem/ChapterItem';
import SubchapterItem from '../components/SubchapterItem/SubchapterItem';

import Lazy from 'lazy.js';

const SubChapterList = React.createClass({
	mixins: [ReactFireMixin],

    contextTypes: {
        userRef: React.PropTypes.object
    },

	getInitialState: function () {
		return {
			book: null,
			chapter: null,
			subChapters: null,
			exercises: null,
            lastViewedExercise: null
		};
	},

	componentWillMount: function () {
		this.bindAsObject(
            firebaseRoot
                .child('content/books')
                .child(this.props.params.bookId),
            "book");
		this.bindAsObject(
            firebaseRoot
                .child('content/chapters')
	            .child(this.props.params.bookId)
	            .child(this.props.params.chapterId),
			"chapter");
		this.bindAsArray(
			firebaseRoot
				.child('content/subchapters')
				.child(this.props.params.bookId)
				.child(this.props.params.chapterId),
			"subChapters");
		this.bindAsArray(
			firebaseRoot
				.child('content/exercises')
				.child(this.props.params.bookId)
				.child(this.props.params.chapterId),
			'exercises');
        this.bindAsObject(
	        firebaseRoot
		        .child('/userData')
		        .child(this.context.userRef.key())
				.child("lastViewedExercise")
		        .child(this.props.params.bookId)
		        .child(this.props.params.chapterId),
	        "lastViewedExercise");
	},

    getExerciseKey(subchapter) {

        let exercise = this.state.lastViewedExercise[this.state.subChapters[subchapter]['.key']]
			? this.state.lastViewedExercise[this.state.subChapters[subchapter]['.key']]
			: this.state.subChapters[subchapter]['firstExercise'];

        return exercise;
    },

    getExerciseProgress(subchapterKey, exerciseKey) {

        const exercisesCount = _.size(this.state.exercises[subchapterKey]);

        let i = 0;
        let progressIndex;
        _.map(this.state.exercises[subchapterKey], (exercise, key) => {
            if(key == exerciseKey) {
                progressIndex = i;
            }
            i ++;
        });

        var r =  {
            total: exercisesCount,
            progress:progressIndex
        };

        return r;

    },

	render() {
		if (!this.areAllBindingsLoaded()) {
			return <div>Loading...</div>;
		}

		return(
			<div className="screen-wrap">
				<MobileHeader
					lessonId={this.props.params.lessonId}
					problemId={this.props.params.problemId}
					bookId={this.props.params.bookId}
					type='default'
					title='Get tutored'
					// Don't show the back button on the root screen.
					backButton={this.props.location.pathname.length > 1}
				/>
				<div className="screen-content">
					<ol className="chapters-list">
						<ChapterItem
							element="li"
						    label={this.state.chapter.name}
                            icon={this.state.chapter.icon}
						>
							<ol className="subchapters-list">
								{
									_.map(this.state.subChapters, (subchapter, subchapterKey) => {
										if (subchapterKey == '.key') return null;

                                        let exerciseKey = this.getExerciseKey(subchapterKey);

                                        const link = `/book/${this.props.params.bookId}/${this.props.params.chapterId}/${subchapter['.key']}/${exerciseKey}`;
                                        const progress = Math.round(((this.getExerciseProgress(subchapterKey, exerciseKey)).progress / (this.getExerciseProgress(subchapterKey, exerciseKey)).total) * 100);

										return (
											<SubchapterItem
												key={subchapter['.key']}
											    state="started"
											    label={subchapter.name}
                                                to={link}
                                                progress={progress}
                                                progressLabel={subchapterKey + 1}
											>
                                                <span className="subchapter-meta">Övning {(this.getExerciseProgress(subchapterKey, exerciseKey)).progress} av {(this.getExerciseProgress(subchapterKey, exerciseKey)).total}</span>
											</SubchapterItem>
										);
									})
								}
							</ol>
						</ChapterItem>
					</ol>
				</div>
			</div>
		);
	}
});

export default SubChapterList;



/** WEBPACK FOOTER **
 ** ./src/screens/SubChapterList.js
 **/